module.exports = __webpack_public_path__ + "img/place-on-map.67a6594c.png";